import PropTypes from 'prop-types';
import { Button } from 'ui';

import useOnboarding from '../hooks/useOnboarding';
import Spinner from '../components/loader/Spinner';
import { ONBOARDING_STEPS } from '../core/constants';
import Onboarding from '../pages/onboarding';
import { signOut } from '../core/utils';
import Layout from './Layout';
import SubscriptionLayout from '../components/onboarding/SubscriptionLayout';

export const ProtectedComponent = ({ children }) => {
  const { currentOnboardingStep, loading, error } = useOnboarding();

  if (loading) {
    return (
      <SubscriptionLayout>
        <div className="flex size-full flex-1 flex-col items-center justify-center space-y-8">
          <h2 className="text-h2 font-semibold">Loading your account...</h2>
          <Spinner className="size-[34px]" />
        </div>
      </SubscriptionLayout>
    );
  }

  if (error) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center space-y-8">
        <div className="space-y-3 text-center">
          <h2 className="text-h2 font-semibold">Your account failed to load.</h2>
          <p className="font-medium">Please contact support for assistance.</p>
        </div>
        <Button title="Sign Out" color="primary" onClick={signOut} />
      </div>
    );
  }

  if (currentOnboardingStep !== ONBOARDING_STEPS.completed) {
    return <Onboarding initialStep={currentOnboardingStep} />;
  }

  if (children) {
    return children;
  }

  return <Layout />;
};

ProtectedComponent.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
};

export default ProtectedComponent;
